import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, createFieldsGroups, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultPhysicalInformation: Map<string, ConfirmationData> = new Map([

]);
export const defaultPhysicalInformation2: Map<string, ConfirmationData> = new Map([
    ["e475dc24-c9fe-4303-9245-decb7f32b6f9", { fontWeight: "bold" }],
    ["1311e79b-14a4-4503-a68d-60de87b784f1|4ce75734-5023-4c15-a37e-0004de0d83e5-kg", { label: "Peso en kilogramos" }],
    ["1311e79b-14a4-4503-a68d-60de87b784f1|4ce75734-5023-4c15-a37e-0004de0d83e5-lb", { label: "Peso en libras", showBorder: true }],
    ["2b826338-8e08-45c7-b4d6-f359ab8d7c79", { fontWeight: "bold" }],
    ["79da1ce0-35cf-49e9-9350-13b3e0742077|2a72a640-b4ac-40dd-8e45-94aa9f07da9f-m", { label: "Talla en metros" }],
    ["79da1ce0-35cf-49e9-9350-13b3e0742077|2a72a640-b4ac-40dd-8e45-94aa9f07da9f-ft", { label: "Talla en pies y pulgadas", showBorder: true }],
    ["6af86b9b-1c91-41dc-995e-b6f22540e402|35ba1e0f-cab1-4433-8b5e-765037412c17", {}],
]);
const weightLoss: Map<string, ConfirmationData> = new Map([
    ["c3ad6705-c267-4a0a-9176-f738b2c6244a|a93ece21-1eb4-4120-b5fc-615ea6e5852b", { hiddenIfEmpty: true, fontWeight: "bold" }],
    ["c3ad6705-c267-4a0a-9176-f738b2c6244a|1b3b2040-c6eb-4b3a-8e06-0f1cc35720f4-kg", { label: "¿Cuánto peso perdió?", hiddenIfEmpty: true }],
]);

const defaultFamilyItems: Map<string, ConfirmationData> = new Map([
    ["group", { label: "", fontWeight: "bold", color: "green" }],
    ["title1", { label: "¿Cuál es tu peso actual?", fontWeight: "bold" }],
    ["4ce75734-5023-4c15-a37e-0004de0d83e5-kg", { label: "Peso en kilogramos" }],
    ["4ce75734-5023-4c15-a37e-0004de0d83e5-lb", { label: "Peso en libras" }],
    ["title2", { label: "¿Cuánto mides?", fontWeight: "bold" }],
    ["2a72a640-b4ac-40dd-8e45-94aa9f07da9f-m", { label: "Talla en metros" }],
    ["2a72a640-b4ac-40dd-8e45-94aa9f07da9f-ft", { label: "Talla en pies y pulgadas" }],
    ["0b53203c-6f6e-4cea-af21-f47dd13d56f1", { label: "¿Has tenido alguna pérdida de peso en el último año?", fontWeight: "bold" }],
    ["a93ece21-1eb4-4120-b5fc-615ea6e5852b", { label: "¿Cuál fue la razón de la pérdida de peso?", hiddenIfEmpty: true }],
    ["1b3b2040-c6eb-4b3a-8e06-0f1cc35720f4-kg", { label: "¿Cuánto peso perdió?", showBorder: true, hiddenIfEmpty: true }],

]);


export const updatePhysicalInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {

    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);


    const section = page.sections.find(section => section.section_id === "4e0f81a8-4280-476b-810e-5ef19b8367af" && section.hidden === false);
    let updatedFamilyItems = new Map<string, ConfirmationData>();
    if (section) {
        const familyGroups = section.groups.filter(group => !group.hidden).sort((a, b) => a.order - b.order);
        updatedFamilyItems = createFieldsGroups(familyGroups, defaultFamilyItems);

    }
    if (updatedFamilyItems.size === 0) {
        cd = new Map([
            ...cd,
            ...defaultPhysicalInformation2,
        ]);
    }

    const value = answersMap.get("6af86b9b-1c91-41dc-995e-b6f22540e402|35ba1e0f-cab1-4433-8b5e-765037412c17")?.value
    if (value !== "No" && value !== "" && updatedFamilyItems.size === 0) {
        cd = new Map([
            ...cd,
            ...weightLoss,
        ]);
    }
    const result = updateMapWithFields(mapToTupleArray(answersMap), new Map([...cd, ...updatedFamilyItems]));
    return result;
}